import React from 'react'
import { components } from 'cng-web-lib'
import PAXLSTInternationalDocFormProperties from './PAXLSTInternationalDocFormProperties'
import { Grid, Tooltip } from '@material-ui/core'

const {
  button: { CngIconButton }
} = components

const { initialValues } = PAXLSTInternationalDocFormProperties.formikProps

function PAXLSTInternationalDocEntry(props) {
  const {
    index,
    parentIndex,
    isLast,
    onAddInternationalDoc,
    onDeleteInternationalDoc,
    internationalDoc,
    showNotification,
    aceIdFlag,
    fastCardFlag
  } = props

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md>
        <PAXLSTInternationalDocFormProperties.Fields index={index} parentIndex={parentIndex} showNotification={showNotification} isRequired={!aceIdFlag && !fastCardFlag} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Add new'>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddInternationalDoc(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Clone'>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddInternationalDoc({ ...internationalDoc, id: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && !aceIdFlag && !fastCardFlag && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteInternationalDoc(internationalDoc)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
          {(aceIdFlag || fastCardFlag) && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteInternationalDoc(internationalDoc)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PAXLSTInternationalDocEntry
